
















































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { mapGetters } from "vuex";
import Subscription from "@/models/subscription";

@Component({
  computed: {
    ...mapGetters("subscriptions", [
      "activeSubscription",
      "pausedSubscription",
      "hasActiveSubscription",
      "hasPausedSubscription",
    ]),
  },
})
export default class ActiveSubscriptionMessage extends Vue {
  // mapState + mapGetters
  hasActiveSubscription!: boolean;
  hasPausedSubscription!: boolean;
  activeSubscription!: Subscription;
  pausedSubscription!: Subscription;
  loading = false;
  poller!: any;
  timesPolled = 0;

  update() {
    // @ts-ignore
    // eslint-disable-next-line no-undef
    Paddle.Checkout.open({
      override: this.activeSubscription.updateUrl,
    });
  }

  updatePaused() {
    // @ts-ignore
    // eslint-disable-next-line no-undef
    Paddle.Checkout.open({
      override: this.pausedSubscription.updateUrl,
    });
  }

  askForCancellation() {
    this.$confirm(
      // @ts-ignore
      `Are you sure you want to cancel your subscription?`,
      "Cancel subscription",
      {
        confirmButtonText: "Cancel subscription",
        cancelButtonText: "Don't cancel",
        type: "warning",
      }
    )
      .then(() => {
        this.cancelSubscription();
      })
      .catch(() => {
        // don't do anything, just handle the promise
      });
  }

  cancelSubscription() {
    // Scoping...
    let that = this;
    // @ts-ignore
    // eslint-disable-next-line no-undef
    Paddle.Checkout.open({
      override: this.activeSubscription.cancelUrl,
      successCallback() {
        //
        // Check status...
        that.pollSubscriptions();
        //
        // Show a message to the user
        that.$message({
          message: "Your subscription has been cancelled.",
          type: "success",
        });
      },
    });
  }

  pollSubscriptions() {
    this.timesPolled++;
    this.loading = true;
    this.poller = setTimeout(() => {
      this.$store.dispatch("subscriptions/getSubscriptions").then(() => {
        if (!this.hasActiveSubscription && this.timesPolled < 5) {
          this.pollSubscriptions();
        } else {
          // cancel the timeout
          clearTimeout(this.poller);
          // cancel loading
          this.loading = false;
          this.timesPolled = 0;
        }
      });
    }, 2000);
  }
}
